import React from 'react'


const Nav = props => {
    return (
        <div className="nav">
            <div
                className="sections"
                style={{
                    background: "white"
                }}
                onClick={props.settings}
            >{props.id}</div>
            <div
                className="sections"
                style={{
                    background: props.nav === 'daily' ? "orange" : 'white'
                }}
                onClick={props.daily}
            >24 hours</div>
            <div
                className="sections"
                style={{
                    background: props.nav === 'days' ? "orange" : 'white'
                }}
                onClick={props.days}
            >30 days</div>
        </div>
        )
}

export default Nav


// WEBPACK FOOTER //
// ./src/ui/item/nav.js